import styled from "@emotion/styled";

export const StylePriceBreakdownGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 20px;
`;

export const SectionCard = styled.div<{ variant?: string }>`
  background: ${({ variant }) =>
    variant === "deduction"
      ? "#fffbfb"
      : variant === "earnings"
        ? "#fbfefc"
        : "#fff"};
  border: 1px solid #f3f4f6;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 8px;
`;

export const SectionTitle = styled.div<{ color?: string }>`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: ${({ color }) => color || "#9ca3af"};
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Row = styled.div<{ indent?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  padding-left: ${({ indent }) => (indent ? "18px" : "0")};
`;

export const RowLabel = styled.span<{
  bold?: boolean;
  small?: boolean;
  muted?: boolean;
}>`
  font-size: ${({ small }) => (small ? "12px" : "13px")};
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  color: ${({ muted }) => (muted ? "#b0b5bd" : "#4b5563")};
`;

export const RowValue = styled.span<{
  color?: string;
  bold?: boolean;
  small?: boolean;
}>`
  font-size: ${({ small }) => (small ? "12px" : "13px")};
  font-weight: ${({ bold }) => (bold ? 600 : 500)};
  color: ${({ color }) => color || "#1f2937"};
  font-variant-numeric: tabular-nums;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  border-radius: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  margin-bottom: 8px;
`;

export const TotalLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
`;

export const TotalValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.2px;
`;
